import swaggerClient from "./../plugins/swagger-client";

const call = (operationId, params, payload) =>
  swaggerClient.swagger
    .then((client) =>
      client.apis.releaseNotes[operationId](
        params || {},
        swaggerClient.buildRequestBody(payload),
        {}
      )
    )
    .then((response) => response.body)
    .catch((error) => Promise.reject(error));

export default class ReleaseNoteService {
  retrieveReleaseNotes() {
    return call("retrieveReleaseNotes");
  }

  createReleaseNote(payload) {
    return call("createReleaseNote", {}, payload);
  }

  updateReleaseNote(releaseNoteId, payload) {
    return call("updateReleaseNote", { releaseNoteId }, payload);
  }

  deleteReleaseNote(releaseNoteId) {
    return call("deleteReleaseNote", { releaseNoteId });
  }

  translateReleaseNote(payload) {
    return call("translateReleaseNote", {}, payload);
  }

  retrieveReleaseNoteJiraIssues(version) {
    return call("retrieveReleaseNoteJiraIssues", { version });
  }

  draftReleaseNotes(payload) {
    return call("draftReleaseNotes", {}, payload);
  }
}
